var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.$store.state.linkInfo.resourceUrl)?_c('div',[_c('div',{staticClass:"desc-text"},[_vm._v("用微信扫描下方的小程序码，打开微信小程序")]),_c('img',{attrs:{"src":_vm.$store.state.linkInfo.resourceUrl}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }